import { useEffect, useRef, useState } from "react";

import type { OverlayPhase } from "./warmHandoffPhase";

export function useStandbyCountdown(phase: OverlayPhase, countdownDuration: number): number {
    const [ringProgress, setRingProgress] = useState(100);
    const animationRef = useRef<number | null>(null);
    const startTimeRef = useRef<number | null>(null);

    useEffect(() => {
        if (phase !== "standby") return;

        startTimeRef.current = null;

        const animate = (now: number) => {
            if (!startTimeRef.current) startTimeRef.current = now;
            const elapsed = (now - startTimeRef.current) / 1000;
            const remaining = Math.max(100 - (elapsed / countdownDuration) * 100, 0);
            setRingProgress(remaining);

            if (remaining > 0) {
                animationRef.current = requestAnimationFrame(animate);
            }
        };

        animationRef.current = requestAnimationFrame(animate);

        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
                animationRef.current = null;
            }
        };
    }, [phase, countdownDuration]);

    return ringProgress;
}
